<template>
    <FilterBase :title>
        <FilterList :no-icons>
            <FilterItemWithImage
                v-for="(item, key) in filter"
                :key
                :add-link="getRouteAdd(filterMapperLabel(item))"
                :disabled
                :image="image(item)"
                :label="item.label.translation.name"
                :no-icons
                :remove-link="getRouteRemove(filterMapperLabel(item))"
                :selected="isSelected(filterMapperLabel(item))"
                :total-results="item.totalResults"
            />
        </FilterList>
    </FilterBase>
</template>

<script
    generic="
        I extends string,
        O extends {
            label: {
                systemCode: I
                translation: { name: string }
                icon: { url: string } | null
            }
            totalResults: number
        }
    "
    lang="ts"
    setup
>
import { computed } from 'vue'

import { filterMapperLabel } from '@/domain/product/ring/engagement'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

import FilterList from '@/components/ui/filter/filters/layout/FilterList.vue'
import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import FilterItemWithImage from '../FilterItemWithImage.vue'

interface Props {
    title?: string
    multiple?: boolean
    filter: O[]
    selected: I[]
    getRouteAdd: (item: I) => ButtonRouteRelative
    getRouteRemove: (item: I) => ButtonRouteRelative
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    multiple: false,
    title: undefined,
})

const noIcons = computed(() => !props.filter.some((item) => item.label.icon))

const image = (item: O) => item.label.icon?.url

const isSelected = (item: I) => props.selected.includes(item)
</script>
